import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
    {
      name: "Sakhiyan 2.0",
      cover:
        "	https://english.cdn.zeenews.com/sites/default/files/2021/08/13/960254-akshay-vaani-new.jpg",
      artist: "Zara Khan",
      audio:
        "https://download02.saregama.com/secure/174228/mp4/3/INH102101873_32_a.mp4?e=0&h=2e0bae49bf9cbbc8d50637d629112e3b",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Mann Bharya 2.0",
      cover:
        "https://media.lyricsmint.com/photos/4930/mann-bharrya-b-praak_cover.jpg",
      artist: "B Praak",
      audio:
        "https://pagalfree.com/musics/128-Mann%20Bharryaa%202.0%20-%20Shershaah%20128%20Kbps.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Raatan Lambiyan",
      cover:
        "https://thehindutimes.com/wp-content/uploads/2021/07/sidsong_d.jpg",
      artist: "Tanishk Bagchi, Jubin Nautiyal, Asees Kaur",
      audio:
        "https://pagalfree.com/musics/128-Raataan Lambiyan - Shershaah 128 Kbps.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Ranjha",
      cover:
        "https://cdn.thelivemirror.com/wp-content/uploads/2021/08/Ranjha-song.jpg",
      artist: "Jasleen Royal, B Praak",
      audio: "https://pagalfree.com/musics/128-Ranjha - Shershaah 128 Kbps.mp3",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Ek Ajanabee",
      cover:
        "https://mrandmrs55.files.wordpress.com/2019/10/ek-ajnabee-haseena-se-awkward-game.png",
      artist: "Kishore Kumar",
      audio:
        "https://download02.saregama.com/secure/174228/mp4/0/INH109243080_32_a.mp4?e=0&h=66269b5890007b5eafc50a8187fe4c74",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Yeh Sham Mastani",
      cover:
        "https://a10.gaanacdn.com/images/albums/94/64094/crop_480x480_64094.jpg",
      artist: "Kishor Kumar",
      audio:
        "https://download02.saregama.com/secure/174228/mp4/0/INH109438860_32_a.mp4?e=0&h=1549175c3ba84e175ee00baa3a2a5cdb",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Kabhi Kabhi",
      cover:
        "http://sargam.sunilanand.in/wp-content/uploads/2020/02/kabhi-kabhie-mere-dil-mein-hindi-song-harmonium-notes.jpg",
      artist: "Mukesh",
      audio:
        "https://download02.saregama.com/secure/174228/mp4/8/INH101004068_32_a.mp4?e=0&h=b20f7fbb6b40d468334b16c8992c2484",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Ek Pyar Ka Nagma Hai",
      cover:
        "https://a10.gaanacdn.com/images/albums/91/1402791/crop_480x480_1402791.jpg",
      artist: "Lata Mangeshkar",
      audio:
        "https://download02.saregama.com/secure/174228/mp4/0/INH100163840_32_a.mp4?e=0&h=4a958bb4ef0f9a6bb645eb5168d3c895",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Tune O Rangele",
      cover:
        "https://www.hindiraag.com/wp-content/uploads/2020/08/tune-oh-rangeele-kaisa.jpg",
      artist: "Lata Mangeshkar",
      audio:
        "https://download02.saregama.com/secure/174228/mp4/0/INH109238690_32_a.mp4?e=0&h=bf95e8f4324d143f15de63633da12d44",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    //ADD MORE HERE
  ];
}

export default chillHop;
